import Swal from "sweetalert2";
import api from "../../../../utilities/interseptor";
import { resistrarIncidente } from "../../../../components/molecules/TablaBitacoras/TablaBitacorasntegracion";
import { DataDecompressor } from "../../../../utilities/descomprimirRespuestas";

const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API
export const getLogs = async (setLogs) => {
    await api.get(apiUrl + `/monitor/tablero/getLogs`).then((res) => {
        setLogs(res.data)

    })
        .catch((error) => {
            console.log("error", error);

        })

}

export const getRoutes = async (setData, id_clinetes, tipoServicio, confirmadoNoConfirmado) => {
    const data = {
        id_cliente: id_clinetes,
        tipo_servicio: tipoServicio,
        confirmadoNoConfirmado: confirmadoNoConfirmado
    }


    await api.post(`${apiUrl}/monitor/tablero/getRutasEnCurso`, data)
        .then((res) => {
            const data = []

            if (res.data) {
                res.data.map((item) => {
                    data.push({ id: item.ID_BITACORA, name: item.NOMBRE, code: item.ID_TRAZO, confirmada: item.CONFIRMADA, unidad: item.UNIDAD, chofer: item.ID_CHOFER })
                })
                setData(data)
            }
            else {
                setData([])
            }
        })
        .catch((error) => {
            // Swal.fire({
            //     icon: "error",
            //     text: error.message,

            // });
        })
}
export const transferenciaAOperadorGuardia = async (id_bitacora_guardia, id_bitacora_cobierta, id_chofer_guardia, ruta, setRuta, dataIncidente, setResIncidente, limpiarDatos) => {
    const data = {
        id_bitacora_guardia: id_bitacora_guardia,
        id_bitacora_cobierta, id_bitacora_cobierta,
        id_chofer: id_chofer_guardia,
        transferido_por: dataIncidente.transferido_por,
        transferido_por_id: dataIncidente.transferido_por_id
    }
    await resistrarIncidente(dataIncidente, setResIncidente, limpiarDatos)
    await api.patch(`${apiUrl}/monitor/tablero/transferirPorIdBitacora`, data)
        .then((res) => {

            if (res.data.message != 'success') {
                Swal.fire({
                    icon: 'error',   // Icono de error
                    title: res.data.message, // Título de la alerta
                    confirmButtonText: 'OK'  // Texto del botón de confirmación
                });
            }
            else {
                Swal.fire({
                    icon: 'success',   // Icono de error
                    title: `Bitacora: ${res.data.id_bitacora_cobierta} transferida con ruta : ${ruta}`, // Título de la alerta
                    confirmButtonText: 'OK'  // Texto del botón de confirmación
                });
                setRuta(null)
            }
        })
        .catch((error) => {
            // Swal.fire({
            //     icon: "error",
            //     text: error.message,

            // });
        })
}

export const getTrazo = (setData, bitacoras, signal, setActualizadorTrazo, actualizadorTrazo) => {


    const data = {
        id_bitacora: bitacoras
    }

    api.post(`${apiUrl}/monitor/tablero/getTrazo`, data, { signal })
        .then((res) => {
            const dataDescomprimida = DataDecompressor.decompressData(res.data)
            setData(dataDescomprimida)
            setActualizadorTrazo(!actualizadorTrazo)
        })
        .catch((error) => {
            // Swal.fire({
            //     icon: "error",
            //     text: error.message,

            // });
        })
}
export const getGuardias = (data, setData) => {




    api.get(`${apiUrl}/monitor/tablero/getGuardias?fecha_inicio=${data.fecha_inicio}&fecha_fin=${data.fecha_fin}`)
        .then((res) => {
            setData(res.data)
        })
        .catch((error) => {
            // Swal.fire({
            //     icon: "error",
            //     text: error.message,

            // });
        })
}

// export const getUnidades  = async (setUnidades, bitacoras,tipoServicio,confirmadoNoConfirmado) => {    

//     await api.get(`${apiUrl}/monitor/tablero/getUnidadesEnRuta?id_bitacora=${bitacoras}&tipo_servicio = ${tipoServicio}&confirmado=${confirmadoNoConfirmado}`)

//         .then((res) => {
//             setUnidades(res.data)
//             return true
//         })
//         .catch((error) => {
//             Swal.fire({
//                 icon: "error",
//                 text: error.message,

//             });
//         })
// }



export const getUnidades = async (setUnidades, bitacoras, tipoServicio, confirmadoNoConfirmado, actualizador, signal) => {

    const data = {
        id_bitacora: bitacoras,
        tipo_servicio: tipoServicio,
        confirmado: confirmadoNoConfirmado

    }
    return await api.post(`${apiUrl}/monitor/tablero/getUnidadesEnRuta`, data, { signal })
        .then((res) => {
            const dataDescomprimida = DataDecompressor.decompressData(res.data)
            setUnidades(dataDescomprimida);


            return !actualizador;
        })
        .catch((error) => {
            // Swal.fire({
            //     icon: "error",
            //     text: error.message,
            // });
            return !actualizador; // Puedes retornar false en caso de error

        });
};
export const getServicios = async (setStatus, signal, data) => {


    return await api.post(`${apiUrl}/monitor/tablero/getServicios`, data, { signal })
        .then((res) => {
            const dataDescomprimida = DataDecompressor.decompressData(res.data)
            setStatus(dataDescomprimida);
        })
        .catch((error) => {
            // Swal.fire({
            //     icon: "error",
            //     text: error.message,
            // });

        });
};
export const getServiciosUnidades = async (setStatus) => {


    return await api.post(`${apiUrl}/monitor/tablero/getServiciosUnidades`)
        .then((res) => {
            const dataDescomprimida = DataDecompressor.decompressData(res.data)
            setStatus(dataDescomprimida);
        })
        .catch((error) => {
            // Swal.fire({
            //     icon: "error",
            //     text: error.message,
            // });

        });
};
export const sendWatsAppOp = async (setStatus, ID_BITACORA, TELEFONO) => {

    const data = {
        id_bitacora: ID_BITACORA,
        telefono: TELEFONO
    }
    await api.post(`${apiUrl}/monitor/tablero/sendWatsApp`, data)
        .then((res) => {
            const dataDescomprimida = DataDecompressor.decompressData(res.data)
            setStatus(dataDescomprimida);
        })
        .catch((error) => {
            // Swal.fire({
            //     icon: "error",
            //     text: error.message,
            // });

        });
};
export const getWatsAppConteo = async (setStatus, ID_BITACORA) => {

    await api.get(`${apiUrl}/monitor/tablero/watsAppEnviados?id_bitacora=${ID_BITACORA}`)
        .then((res) => {
            const dataDescomprimida = DataDecompressor.decompressData(res.data)
            setStatus(dataDescomprimida);
        })
        .catch((error) => {
            // Swal.fire({
            //     icon: "error",
            //     text: error.message,
            // });

        });
};
export const getPosicionUnidades = async (id_unidades) => {
    const data = {
        id_unidades: id_unidades
    }
    try {
        const res = await api.post(`${apiUrl}/monitor/tablero/getPosicionUnidades`, data)
        if (res) {
            const dataDescomprimida = DataDecompressor.decompressData(res.data)
            // setStatus(dataDescomprimida);
            return dataDescomprimida
        }
    }
    catch (error) {
        console.log("Error en getPosicionUnidades:", error);
    }
};
export const getVelocidadUnidad = async (setStatus, id_unidad_wialon) => {

    try {
        const res = await api.get(`${apiUrl}/monitor/tablero/getVelocidadUnidad?id_unidad_wialon=${id_unidad_wialon}`)
        if (res) {
            const dataDescomprimida = DataDecompressor.decompressData(res.data)
            // setStatus(dataDescomprimida);
            setStatus(dataDescomprimida)
            return dataDescomprimida
        }
    }
    catch (error) {
        console.log("Error en getPosicionUnidades:", error);
    }
};
export const sendWatsAppCliente = async (telefono, mensaje) => {
    try {
        const data = {
            telefono: telefono,
            mensaje: mensaje
        }
        await api.post(`${apiUrl}/monitor/tablero/sendClientWhatsApp`, data)

    }
    catch (error) {
        console.log("Error en getPosicionUnidades:", error);
    }
};